import { LEGAL, addressHtml } from "~/config/legal";

const address = addressHtml();

// `body` fields are trusted HTML authored here, rendered into the .ss-prose
// container. They never contain user input.
const ar = {
  eyebrow: "قانوني",
  lastUpdatedLabel: "آخر تحديث",
  questionsTitle: "أسئلة حول هذه السياسة؟",
  questionsBody: `يمكنك التواصل معنا في أي وقت عبر ${LEGAL.email}.`,

  incompleteWarning:
    "هذا الإشعار القانوني غير مكتمل. لا يزال على المشغّل تقديم البيانات المطلوبة بموجب §5 DDG.",

  // ── Imprint / Impressum ─────────────────────────────────────────────────
  imprint: {
    metaTitle: "SkillSynergy | بيانات الناشر",
    metaDescription:
      "الإشعار القانوني وبيانات تعريف المزوّد الخاصة بـ SkillSynergy.",
    title: "بيانات الناشر",
    sections: [
      {
        h: "معلومات وفقًا لـ §5 DDG",
        body: `<p>${address}</p>`,
      },
      {
        h: "التواصل",
        body: `<p>الهاتف: <a href="tel:${LEGAL.phone.replace(/\s/g, "")}">${LEGAL.phone}</a><br>البريد الإلكتروني: <a href="mailto:${LEGAL.email}">${LEGAL.email}</a></p>`,
      },
      {
        h: "رقم تعريف ضريبة القيمة المضافة",
        body: `<p>رقم تعريف ضريبة القيمة المضافة وفقًا لـ §27a من قانون ضريبة القيمة المضافة الألماني (UStG): ${LEGAL.vatId}</p>`,
      },
      {
        h: "المسؤول عن المحتوى وفقًا لـ §18(2) MStV",
        body: `<p>${LEGAL.contentResponsible}<br>${LEGAL.street}, ${LEGAL.postalCode} ${LEGAL.city}</p>`,
      },
      {
        h: "تسوية منازعات المستهلكين",
        body: `<p>لسنا ملزمين ولا راغبين في المشاركة في إجراءات تسوية المنازعات أمام هيئة تحكيم لشؤون المستهلكين (Verbraucherschlichtungsstelle) بالمعنى المقصود في §36 VSBG.</p>`,
      },
      {
        h: "المسؤولية عن الروابط",
        body: `<p>يحتوي موقعنا على روابط إلى مواقع خارجية لا نملك أي سيطرة على محتواها. لا نتحمّل أي مسؤولية عن محتوى الغير هذا. المزوّد أو المشغّل المعني للصفحات المرتبطة هو المسؤول دائمًا عن محتواها.</p>`,
      },
    ],
  },

  // ── Privacy policy ───────────────────────────────────────────────────────
  privacy: {
    metaTitle: "SkillSynergy | سياسة الخصوصية",
    metaDescription:
      "كيف تجمع SkillSynergy بياناتك الشخصية وتستخدمها وتحميها، وكيف تمارس حقوقك بموجب اللائحة العامة لحماية البيانات (GDPR).",
    title: "سياسة الخصوصية",
    sections: [
      {
        h: "1. من المسؤول عن بياناتك",
        body: `<p>المتحكّم في المعالجة الموصوفة هنا، بالمعنى المقصود في المادة 4(7) من GDPR، هو:</p>
<p>${address}<br>البريد الإلكتروني: <a href="mailto:${LEGAL.email}">${LEGAL.email}</a><br>الهاتف: ${LEGAL.phone}</p>
<p>لم نعيّن مسؤولًا عن حماية البيانات، إذ لسنا مطالبين بذلك بموجب المادة 37 من GDPR.</p>`,
      },
      {
        h: "2. ما نجمعه، ولماذا",
        body: `<p>لا نعالج البيانات الشخصية إلا حين يكون لدينا أساس قانوني بموجب المادة 6(1) من GDPR.</p>
<table>
  <thead><tr><th>ماذا</th><th>لماذا</th><th>الأساس القانوني</th><th>مدة الحفظ</th></tr></thead>
  <tbody>
    <tr><td>سجلّات الخادم: عنوان IP، ووكيل المستخدم، وعنوان URL المطلوب، والطابع الزمني</td><td>تقديم الموقع والدفاع عنه ضد إساءة الاستخدام</td><td>المادة 6(1)(f)، مصلحتنا المشروعة في موقع يعمل بأمان</td><td>يحتفظ به مزوّد الاستضافة لدينا لفترة وجيزة. ولا نحتفظ نحن بأي سجلّات خاصة بنا.</td></tr>
    <tr><td>الدولة، المستنتجة من عنوان IP الخاص بك عند الحافة</td><td>عرض الأسعار بعملتك</td><td>المادة 6(1)(f)، مصلحتنا المشروعة في عرض أسعار ملائمة. أما عنوان IP نفسه فلا نخزّنه ولا نسجّله.</td><td>غير مخزّن</td></tr>
    <tr><td>نموذج التواصل: الاسم، والبريد الإلكتروني، والموضوع، والرسالة</td><td>الردّ على استفسارك. تُخزَّن رسالتك في قاعدة بياناتنا إلى أن ننتهي من معالجتها.</td><td>المادة 6(1)(a) الموافقة، والمادة 6(1)(b) حين يتعلّق استفسارك بعقد</td><td>تُحذف تلقائيًا بعد 24 شهرًا</td></tr>
    <tr><td>نموذج الحجز: الاسم، والبريد الإلكتروني، والدورة، والمسار، والوقت المفضّل</td><td>ترتيب استشارتك المجانية. تُخزَّن في قاعدة بياناتنا إلى أن ننتهي من ترتيبها.</td><td>المادة 6(1)(a) الموافقة، والمادة 6(1)(b) الخطوات السابقة على عقد</td><td>تُحذف تلقائيًا بعد 24 شهرًا</td></tr>
    <tr><td>تجزئة مملّحة لعنوان IP الخاص بك، عند إرسالك نموذجًا</td><td>الحدّ من عمليات الإرسال المتكرّرة من المصدر نفسه (الحماية من البريد المزعج). لا يُخزَّن عنوان IP الخام إطلاقًا، بل تجزئة مفتاحية له فقط.</td><td>المادة 6(1)(f)، مصلحتنا المشروعة في منع إساءة استخدام نماذجنا</td><td>تُحذف تلقائيًا بعد 24 شهرًا</td></tr>
    <tr><td>معاملات الحملة (utm_) من الرابط الذي وصلت عبره، والموقع المُحيل، تُرسل مع النموذج</td><td>معرفة الإعلان أو الرابط الذي أوصل إلينا الطلب. لا يُخزَّن أي شيء على جهازك لهذا الغرض، ولا تشارك أي خدمة تتبّع.</td><td>المادة 6(1)(f)، مصلحتنا المشروعة في قياس إعلاناتنا</td><td>تُحفظ مع الطلب وتُحذف معه بعد 24 شهرًا</td></tr>
    <tr><td>اختيارك لملفات تعريف الارتباط</td><td>تذكّر ما وافقت عليه</td><td>المادة 6(1)(c)، التزامنا باحترام اختيارك</td><td>مخزّن في متصفحك إلى أن تمحوه</td></tr>
    <tr><td>تقارير الأخطاء، فقط إذا فعّلتها: عنوان IP، والمتصفح، وتتبّع المكدّس</td><td>إيجاد الأعطال وإصلاحها</td><td>المادة 6(1)(a) الموافقة</td><td>90 يومًا</td></tr>
  </tbody>
</table>
<p>لست مضطرًا إلى تقديم أيٍّ من هذه البيانات. إن لم تملأ نموذجًا، فلن تتمكّن ببساطة من استخدام ذلك النموذج.</p>`,
      },
      {
        h: "3. ملفات تعريف الارتباط والتقنيات المشابهة",
        body: `<p>لا نضبط أي ملفات تعريف ارتباط لأغراض الإعلان أو التتبّع أو تحديد السمات، ولا نستخدم Google Analytics أو أي منتج مماثل.</p>
<p>يُضبط التخزين <b>الضروري تمامًا</b> دون موافقة لأنه لا يخدم سوى احترام اختيار قمت به: إدخال واحد في التخزين المحلي لمتصفحك يسجّل الفئات التي وافقت عليها. ولا يُرسل أبدًا إلى خوادمنا.</p>
<p><b>كل ما عدا ذلك معطّل إلى أن تفعّله.</b> لا يُحمّل الإبلاغ عن الأخطاء إلا بعد موافقتك، تماشيًا مع §25(1) TDDDG. يمكنك تغيير اختيارك أو سحبه في أي وقت عبر <b>إعدادات ملفات تعريف الارتباط</b> في التذييل، مع سريان المفعول مستقبلًا.</p>`,
      },
      {
        h: "4. من يطّلع أيضًا على بياناتك",
        body: `<p>لا نبيع بياناتك الشخصية، ولن نفعل ذلك أبدًا. نشاركها فقط مع معالجي البيانات الذين نحتاجهم لتشغيل الخدمة، كلٌّ منهم بموجب عقد يستوفي المادة 28 من GDPR.</p>
<ul>
  <li><b>Vercel Inc.</b> (الولايات المتحدة) تستضيف الموقع. تُقدَّم الطلبات من مناطق الاتحاد الأوروبي. تعتمد عمليات النقل على البنود التعاقدية النموذجية وشهادة Vercel لإطار خصوصية البيانات بين الاتحاد الأوروبي والولايات المتحدة.</li>
  <li><b>Functional Software, Inc. (Sentry)</b> تتلقّى تقارير الأخطاء، <i>فقط إذا وافقت</i>. تُخزَّن البيانات في منطقة Sentry بالاتحاد الأوروبي (<code>de.sentry.io</code>).</li>
  <li><b>Neon, Inc. (a Databricks company)</b> توفّر قاعدة البيانات التي تخزّن بيانات التواصل والحجز التي تقدّمها. تُستضاف قاعدة البيانات في الاتحاد الأوروبي (Frankfurt)، وتعمل Neon بصفتها معالج البيانات لدينا بموجب اتفاقية معالجة بيانات.</li>
</ul>`,
      },
      {
        h: "5. عمليات النقل خارج الاتحاد الأوروبي",
        body: `<p>حين يكون معالج البيانات قائمًا خارج المنطقة الاقتصادية الأوروبية، أو قد يصل إلى البيانات من خارجها، نعتمد على البنود التعاقدية النموذجية للمفوضية الأوروبية بموجب المادة 46(2)(c) من GDPR، أو على قرار كفاية بموجب المادة 45، أو على إطار خصوصية البيانات بين الاتحاد الأوروبي والولايات المتحدة. يمكنك طلب نسخة من الضمانات ذات الصلة منا في أي وقت.</p>`,
      },
      {
        h: "6. حقوقك",
        body: `<p>بموجب GDPR يحقّ لك:</p>
<ul>
  <li>الحصول على تأكيد بما إذا كنا نعالج بياناتك، ونسخة منها (المادة 15)؛</li>
  <li>تصحيح البيانات غير الدقيقة (المادة 16)؛</li>
  <li>محو بياناتك (المادة 17)؛</li>
  <li>تقييد المعالجة (المادة 18)؛</li>
  <li>تلقّي بياناتك بصيغة قابلة للنقل ومقروءة آليًا (المادة 20)؛</li>
  <li><b>الاعتراض على المعالجة القائمة على مصالحنا المشروعة</b> (المادة 21)؛ و</li>
  <li><b>سحب أي موافقة في أي وقت</b>، دون المساس بمشروعية المعالجة التي جرت قبل السحب (المادة 7(3)).</li>
</ul>
<p>لممارسة أيٍّ من هذه الحقوق، راسلنا على <a href="mailto:${LEGAL.email}">${LEGAL.email}</a>. نردّ خلال شهر واحد.</p>`,
      },
      {
        h: "7. الشكاوى",
        body: `<p>إن رأيت أننا نعالج بياناتك بشكل غير قانوني، يمكنك تقديم شكوى إلى سلطة رقابية، لا سيما في الدولة العضو التي تقيم أو تعمل فيها (المادة 77 من GDPR). السلطة المختصة بنا هي <a href="${LEGAL.supervisoryAuthority.url}" target="_blank" rel="noopener noreferrer">${LEGAL.supervisoryAuthority.name}</a>.</p>`,
      },
      {
        h: "8. الأمان",
        body: `<p>يُقدَّم الموقع حصريًا عبر بروتوكول TLS. نطبّق تدابير تقنية وتنظيمية ملائمة للمخاطر، كما تقتضيه المادة 32 من GDPR، ونحصر البيانات الشخصية التي نحتفظ بها في الحدّ الأدنى الذي يتطلّبه الغرض.</p>`,
      },
      {
        h: "9. التغييرات على هذه السياسة",
        body: `<p>نحدّث هذه السياسة حين تتغيّر معالجتنا للبيانات. تحمل النسخة الحالية دائمًا التاريخ المبيّن أعلى هذه الصفحة.</p>`,
      },
    ],
  },

  // ── Terms ────────────────────────────────────────────────────────────────
  terms: {
    metaTitle: "SkillSynergy | شروط الخدمة",
    metaDescription:
      "الشروط التي تحكم التسجيل في دورات SkillSynergy، بما في ذلك الأسعار وحقّ الانسحاب القانوني والاستخدام المقبول.",
    title: "شروط الخدمة",
    sections: [
      {
        h: "1. النطاق والمزوّد",
        body: `<p>تحكم هذه الشروط كل عقد يُبرم بينك وبين ${LEGAL.entityName}، ${LEGAL.street}، ${LEGAL.postalCode} ${LEGAL.city}، عبر هذا الموقع. لا تسري الشروط المتعارضة الخاصة بك ما لم نوافق عليها كتابةً.</p>`,
      },
      {
        h: "2. الدورات والتسجيل",
        body: `<p>عرض دورة على هذا الموقع دعوة إلى التعاقد، لا عرضًا ملزمًا. ينشأ العقد حين نؤكّد تسجيلك عبر البريد الإلكتروني. يمنحك التسجيل الوصول إلى الجلسات المباشرة والتسجيلات والمواد الخاصة بالباقة التي اخترتها. قد تُعدَّل الجداول والصيغ والمحتوى حيثما لا يقلّل ذلك من قيمة الدورة.</p>`,
      },
      {
        h: "3. الأسعار والدفع",
        body: `<p>تُعرض الأسعار بالعملة المطابقة لدولتك وتشمل ضريبة القيمة المضافة القانونية حيثما انطبقت. لا تسري الأسعار الترويجية إلا للمدة المذكورة. الرسوم مستحقة الدفع مقدّمًا ما لم يُتّفق على خلاف ذلك.</p>`,
      },
      {
        h: "4. حقّ الانسحاب للمستهلكين",
        body: `<p><b>إن كنت مستهلكًا، يحقّ لك الانسحاب من هذا العقد خلال 14 يومًا دون إبداء أي سبب.</b> تنتهي مدة الانسحاب بعد 14 يومًا من اليوم الذي أُبرم فيه العقد.</p>
<p>لممارسة هذا الحقّ، أبلغنا ببيان صريح لا لبس فيه، مثل رسالة تُرسل بالبريد أو بريد إلكتروني إلى <a href="mailto:${LEGAL.email}">${LEGAL.email}</a>. يكفي إرسال بلاغك قبل انتهاء المدة.</p>
<p>في حال انسحابك، نردّ جميع المدفوعات التي تلقّيناها منك دون تأخير لا مبرّر له وفي موعد أقصاه 14 يومًا من اليوم الذي أُبلغنا فيه، باستخدام وسيلة الدفع نفسها التي استخدمتها.</p>
<p>حيث طلبت منا صراحةً بدء الدورة خلال مدة الانسحاب، تكون مدينًا لنا بمبلغ متناسب مع ما قُدّم حتى لحظة الانسحاب. يسقط حقّ الانسحاب بمجرّد تنفيذ الدورة بالكامل، وقد أقررت عند الطلب بأنك ستفقده عند التنفيذ الكامل.</p>`,
      },
      {
        h: "5. الاستخدام المقبول",
        body: `<p>توافق على عدم مشاركة حسابك، أو إعادة توزيع التسجيلات أو المواد، أو تعطيل الجلسات المباشرة. يجوز لنا تعليق الحسابات التي تخالف هذه الشروط أو تضرّ بمتعلّمين آخرين، بعد تحذيرك حيثما سمحت الظروف.</p>`,
      },
      {
        h: "6. الملكية الفكرية",
        body: `<p>تبقى مواد الدورة والشيفرة والمحتوى ملكًا لـ ${LEGAL.entityName} ومدرّبيها. تحصل على ترخيص شخصي وغير قابل للنقل وغير حصري لاستخدامها في تعلّمك الخاص، ما دام تسجيلك ساريًا.</p>`,
      },
      {
        h: "7. المسؤولية",
        body: `<p>نتحمّل المسؤولية دون حدود عن العمد والإهمال الجسيم، وعن الإضرار بالحياة أو الجسد أو الصحة. أما عن الإهمال البسيط فلا نتحمّل المسؤولية إلا حين يُخالَف التزام تعاقدي جوهري، وعندئذٍ فقط عن الضرر المتوقّع المعتاد لهذا النوع من العقود. لا تتأثر المسؤولية بموجب قانون المسؤولية عن المنتجات الألماني.</p>`,
      },
      {
        h: "8. القانون الحاكم والاختصاص القضائي",
        body: `<p>يسري القانون الألماني، باستثناء اتفاقية الأمم المتحدة بشأن عقود البيع الدولي للبضائع. إن كنت مستهلكًا مقيمًا بشكل معتاد في الاتحاد الأوروبي، فلا يحرمك هذا الاختيار من الحماية التي توفّرها الأحكام الإلزامية لقانون بلد إقامتك.</p>`,
      },
      {
        h: "9. تسوية منازعات المستهلكين",
        body: `<p>لسنا ملزمين ولا راغبين في المشاركة في إجراءات تسوية المنازعات أمام هيئة تحكيم لشؤون المستهلكين (§36 VSBG).</p>`,
      },
      {
        h: "10. التغييرات على هذه الشروط",
        body: `<p>يجوز لنا تعديل هذه الشروط حيثما كان ذلك ضروريًا ومعقولًا بالنسبة لك. سنُخطرك قبل 30 يومًا على الأقل من سريان أي تغيير. إن اعترضت خلال تلك المدة، يجوز لنا إنهاء العقد عند لحظة سريان التغيير.</p>`,
      },
    ],
  },
};

export default ar;
